// Centralised SEO defaults + per-page helper. React 19 hoists <title>/<meta>/<link>
// tags rendered anywhere in the tree into <head> automatically, so no library needed.
//
// Usage:
//   <SEO
//     title="Products"
//     description="..."
//     path="/products"
//   />
//
// To override OG image (e.g. per product), pass `ogImage` as an absolute URL.

import { SITE_URL, DEFAULT_OG } from "@/data/site";

const trim = (s, n = 160) => {
  if (!s) return "";
  const t = s.replace(/\s+/g, " ").trim();
  return t.length > n ? `${t.slice(0, n - 1)}…` : t;
};

const SEO = ({
  title,
  description,
  path = "/",
  ogImage,
  noindex = false,
}) => {
  const fullTitle = title
    ? `${title} — Vaymilo`
    : "Vaymilo — Simple digital tools for smarter work";
  const desc = trim(
    description ||
      "Vaymilo creates practical AI kits, templates, and workflows to help you write, plan, organize, and create faster."
  );
  const canonical = `${SITE_URL}${path}`;
  const image = ogImage || DEFAULT_OG;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Vaymilo" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />
    </>
  );
};

export default SEO;
